import { render, staticRenderFns } from "./WorkspaceSelect.vue?vue&type=template&id=2a31adca&scoped=true&"
import script from "./WorkspaceSelect.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSelect.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSelect.vue?vue&type=style&index=0&id=2a31adca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31adca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VList,VMenu,VRow,VTextField})
